
import { Link } from 'react-router-dom';

export const Logo = () => {
  return (
    <Link to="/" className="flex items-center">
      <img 
        src="/lovable-uploads/c6bb0acf-bdb6-4158-acf2-04cf2504c9fd.png" 
        alt="Qoop Logo" 
        className="h-8 w-auto"
      />
    </Link>
  );
};
